import React, { useState, useMemo } from "react";
import KendoInboxGrid from "./KendoInboxGrid";
import MainLayout from "../layout";

const Inbox = () => {
  const [Trigger, setTrigger] = useState({
    reRender: false,
    show: false,
    checked: true,
  });
  const renderGrid = useMemo(
    () => ({
      reload: Trigger.reRender,
    }),
    [Trigger.reRender]
  );

  return (
    <MainLayout>
      <div className="tab-pane">
        <div role="tabpanel" className="tab-pane active page-content-wrapper">
          <div className="table-panel task-table m-t-15">
            <div className="row table-panel-header">
              <div className="col-md-8 col-sm-8">
                <h6>Inbox List</h6>
              </div>
              <div className="col-md-4 col-sm-12">
                <div className="row flex-center-end row">
                  <div className="col-md-4 col-sm-4">&nbsp;</div>
                </div>
              </div>
            </div>
            <div className="table-panel-body" id="gridWidth">
              <KendoInboxGrid renderGrid={renderGrid} />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Inbox;
